import { createFileRoute, redirect } from '@tanstack/react-router'

import PendingComponent from '@/components/pending-component'
import { Permission } from '@/lib/permissions'
import { reportConfigurationDetailsQuery } from '@/queries/report-configuration-details.query'

export const Route = createFileRoute('/_dashboard/site/$id/reports/configuration/edit/$reportId/')({
  loader({ params, context: { queryClient } }) {
    return queryClient.ensureQueryData(reportConfigurationDetailsQuery({ siteId: params.id, reportParamId: params.reportId }))
  },
  beforeLoad({ context }) {
    if (!context.user?.hasPermission(Permission.REPORT_CONFIGURATION) && !context.user?.hasPermission(Permission.EDIT_ALL)) {
      throw redirect({
        to: '/403',
      })
    }
  },
  pendingComponent: PendingComponent,
})
